var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49805 7.5V5.5H15.498V7.5H6.49805ZM6.49805 10.5V8.5H15.498V10.5H6.49805ZM9.49805 20.5H3.49805C2.66471 20.5 1.95638 20.2083 1.37305 19.625C0.789714 19.0417 0.498047 18.3333 0.498047 17.5V14.5H3.49805V0.5H18.498V9.525C18.1647 9.49167 17.8272 9.50417 17.4855 9.5625C17.1439 9.62083 16.8147 9.725 16.498 9.875V2.5H5.49805V14.5H11.498L9.49805 16.5H2.49805V17.5C2.49805 17.7833 2.59388 18.0208 2.78555 18.2125C2.97721 18.4042 3.21471 18.5 3.49805 18.5H9.49805V20.5ZM11.498 20.5V17.425L17.023 11.925C17.173 11.775 17.3397 11.6667 17.523 11.6C17.7064 11.5333 17.8897 11.5 18.073 11.5C18.273 11.5 18.4647 11.5375 18.648 11.6125C18.8314 11.6875 18.998 11.8 19.148 11.95L20.073 12.875C20.2064 13.025 20.3105 13.1917 20.3855 13.375C20.4605 13.5583 20.498 13.7417 20.498 13.925C20.498 14.1083 20.4647 14.2958 20.398 14.4875C20.3314 14.6792 20.223 14.85 20.073 15L14.573 20.5H11.498ZM12.998 19H13.948L16.973 15.95L16.523 15.475L16.048 15.025L12.998 18.05V19ZM16.523 15.475L16.048 15.025L16.973 15.95L16.523 15.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.66457d6cf8cdd32e61c5199afaae559f.svg";
export { ForwardRef as ReactComponent };